import * as React from 'react';
import styled from 'styled-components';

import { InputRow } from '../ui/form/InputRow';
import { Input } from '../ui/form/Input';
import { Button } from '../ui/button/Button';
import { Route, Switch, useParams, useRouteMatch } from 'react-router';
import AdminPanel from '../layout/admin/AdminPanel';
import { stat } from 'fs';
import { ArticleEditor } from '../layout/admin/article/Editor';

//GraphQL
import { getAdminClient } from '../layout/admin/AdminApolloClient';
import { gql, useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { IS_LOGGED_IN } from '../../../client/__graphql__/queries/admin/isLoggedIn';
import { LOGIN_QUERY } from '../../../client/__graphql__/mutations/admin/login';
import { Protected } from '../hoc/Protected';

const client = getAdminClient();

interface AdminContext {
  adminState: AdminState;
  setAdminState: any;
}

interface AdminState {
  news: [];
  newsSearch: {
    category: string;
    published: number;
  };
  texts: {
    intro: string;
    kontakt: string;
    meglere: string;
  };
  loggedIn: {
    status: boolean;
    urltag: string | null;
    user: any | null;
  };
}

const initialState: AdminState = {
  news: [],
  newsSearch: {
    category: '',
    published: -1,
  },
  texts: {
    intro: '',
    kontakt: '',
    meglere: '',
  },
  loggedIn: { status: false, urltag: null, user: null },
};

export const AdminContext = React.createContext<AdminContext>({
  adminState: initialState,
  setAdminState: null,
});

const Admin: React.FC<{ history: any }> = (props) => {
  const [adminState, setAdminState] = React.useState<AdminState>(initialState);

  const [state, setState] = React.useState({
    username: '',
    password: '',
  });

  const [login, { data, loading, error }] = useMutation(LOGIN_QUERY, {
    client,
    onCompleted: ({ login }) => {
      if (login?.status) {
        setAdminState({
          ...adminState,
          loggedIn: {
            status: login.status,
            urltag: login.urltag,
            user: login.user,
          },
        });
        props.history.push(CreateAdminUrl(login.urltag, login?.menuOption));
      }
      clearState();
    },
  });

  const clearState = () => {
    setState({
      ...state,
      ['username']: '',
      ['password']: '',
    });
  };

  const handleChange = (e: any) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  // Oppretter ny bolig ved tastetrykk (enter)
  const handleKeypress = async (e: any) => {
    e.preventDefault();
    if (e.key === 'Enter') {
      submit(e);
    }
  };

  const submit = (e: any) => {
    login({
      variables: {
        input: {
          username: state.username,
          password: state.password,
        },
      },
    });
  };

  return (
    <AdminContext.Provider value={{ adminState, setAdminState }}>
      <Switch>
        <Route
          exact
          path="/admin"
          render={() => (
            <Admincontent>
              <AdminH1>Logg inn</AdminH1>
              <Login>
                <InputRow>
                  <Input
                    name="username"
                    type="text"
                    label="E-post"
                    value={state.username}
                    onKeyUp={handleKeypress}
                    onChange={handleChange}
                    placeholder="E-post"
                  />
                </InputRow>
                <InputRow>
                  <Input
                    name="password"
                    type="password"
                    label="Passord"
                    value={state.password}
                    onKeyUp={handleKeypress}
                    onChange={handleChange}
                    placeholder="Passord"
                  />
                </InputRow>
                <Button type="primary" colorTheme="gold" onClick={submit}>
                  Logg inn
                </Button>
              </Login>
            </Admincontent>
          )}
        />
        <Protected>
          <Switch>
            <Route
              exact
              path="/admin/edit/:kontor/editor/:category?"
              component={ArticleEditor}
            />
            <Route
              exact
              path="/admin/edit/:kontor/:slug"
              component={ArticleEditor}
            />
            <Route
              exact
              path="/admin/:kontor/:option?/:category?"
              component={AdminPanel}
            />
          </Switch>
        </Protected>
      </Switch>
    </AdminContext.Provider>
  );
};

const Login = styled.div`
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
  padding: 2em;
  background-color: #000;
  margin-bottom: 4em;
`;

export const Admincontent = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  background-color: #23030a;
  margin-top: 4em;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const AdminH1 = styled.h1`
  padding-top: 1em;
`;

export const Admincontent2 = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  background-color: #23030a;
  margin-top: 1em;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export default Admin;

export const CreateAdminUrl = (
  urltag: string | null | undefined,
  menuOption: string | null | undefined
): string => {
  let url =
    (window.__ENV__.baseUrl ? '/' + window.__ENV__.baseUrl : '') + '/admin';

  if (urltag) {
    url += '/' + urltag + (menuOption ? '/' + menuOption : '');
  }

  return url;
};
